<template>
	<div class="layout">
		<div class="layout__header">
			<div class="layout__title">
				<h3>Créditos agendados</h3>
			</div>
		</div>
		<div class="table-responsive">
			<table>
				<thead>
					<tr>
						<th>Cliente</th>
						<th>Cédula</th>
						<th>Crédito</th>
						<th>Fecha próximo pago</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(registro, index) in registros" :key="registro.id">
						<td scope="row">
							<label :for="'check_' + registro.id">
								<input type="checkbox" :name="'check_' + registro.id" :id="'check_' + registro.id"
									v-model="registro.seleccionado" />
								<span>{{ registro.prestamo.cliente.apellidos_nombres }}</span>
							</label>
						</td>
						<td>{{ registro.prestamo.cliente.numero_identificacion }}</td>
						<td>{{ registro.prestamo.numero_documento }}</td>
						<td>{{ registro.fecha_proximo_pago }}</td>
					</tr>
				</tbody>
				<tfoot>
					<tr v-show="registros.length < 1">
						<td colspan="6">
							<strong> No hay créditos agendados. </strong>
						</td>
					</tr>
				</tfoot>
			</table>
		</div>
		<div class="modal-buttons">
			<button @click="guardar" class="btn-success">
				<i class="fa fa-save"></i><span>Guardar</span>
			</button>
			<button @click="cerrar" class="btn-danger btn--text">
				<i class="fa fa-times"></i><span>Cerrar</span>
			</button>
		</div>
	</div>
</template>
  
<script>
import moment from "moment";

export default {
	props: {
		rutaCobroId: {
			required: false,
			default: ""
		}
	},
	data: function () {
		return {
			registros: [],
			form: {
				rutaCobroId: this.rutaCobroId
			}
		}
	},
	methods: {
		cerrar: function () {
			this.$emit("cerrar");
		},
		guardar: function () {
			const futuros = this.registros.filter(item => item.seleccionado);
			this.$emit("guardar", futuros);
		},
		cargarCreditos: function () {
			const urlApi = `${url}/rutas-cobros/cargar-creditos-agendados`;
			this.registros.splice(0, this.registros.length);
			axios
				.get(urlApi, {
					params: this.form
				})
				.then(({ data }) => {
					this.registros = data.creditos.map(item => {
						item.seleccionado = false;
						item.fecha_proximo_pago = item.fecha_proximo_pago ? moment(item.fecha_proximo_pago).format("YYYY-MM-DD") : "";
						return item;
					});
				})
				.catch(error => {
					swal('Error', 'Hubo un error al cargar los registros', 'error');
				});
		}
	},
	mounted: function () {
		this.cargarCreditos();
	}
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/prestamos/cobros/CreditosAgendados.vue